import { requestGooseAPI, getAPIPath } from '../shared/request'
import { CLIENT_ORDER_ID_PATH } from '../types/constants'
import { OrderClientDto } from '../types/api'

export const ClientOrderService = {
  getOrder: async (locationName: string, orderId: string): Promise<OrderClientDto> => {
    return requestGooseAPI<OrderClientDto>({
      url: getAPIPath(CLIENT_ORDER_ID_PATH, { locationId: locationName, id: orderId }),
      method: 'GET',
      params: {
        includes: [
          'invoices.location',
          'invoices.period',
          'invoices.transactions',
          'payments.transactions',
          'primaryServiceType.serviceType',
          'primaryServiceType.locationBookingConf',
          'invoices.items.offer.locationServiceType',
        ],
      },
    })
  },
}
